import { createUserSessionContext, type UserSessionContext } from '@shared/lib'

/**
 * Контекст возврата с оплаты пополнения.
 *
 * Платёжный шлюз возвращает участника на адрес страницы, а по адресу не узнать, какой заказ он
 * оплачивал. Поэтому номер заказа (`transaction_id` из ответа `topup/`) запоминается перед
 * переходом, а после возврата по нему ищется строка истории и читается её статус.
 *
 * Хранится в `sessionStorage`: это контекст одного похода, он не должен пережить вкладку. Запись
 * подписана участником — чужая игнорируется, как у `proctorReturn`. Адреса оплаты здесь нет:
 * он одноразовый и уходит только в `location.assign`.
 */
const store = createUserSessionContext('topup_return', 'transactionId')

export type TopUpReturnContext = UserSessionContext<'transactionId'>

/** Запомнить заказ перед уходом на оплату. Недоступное хранилище переход не срывает. */
export function saveTopUpReturn(context: TopUpReturnContext): void {
  store.save(context)
}

/** Контекст текущего участника, если он есть и принадлежит именно ему. */
export function readTopUpReturn(userId: number | null | undefined): TopUpReturnContext | null {
  return store.read(userId)
}

/**
 * Забыть контекст: при выходе, при закрытии окна исхода, на `paid`, на пределе ожидания и когда
 * ответ `topup/` пришёл без номера заказа (опрашивать нечего). На `error` не забывается: статус
 * ещё может смениться на `paid`.
 */
export function clearTopUpReturn(): void {
  store.clear()
}
